<template>
  <div class="payment-method-cards" data-test="ideal-method-details">
    <div class="row">
      <div class="col-sm-12 text-left">
        <form>
          <legend>{{ $t("paymentdetails.IDEAL.title") }}</legend>
          <div class="row">
            <div class="col-sm-12">
              <button-issuer
                :issuername="value"
                :issuercode="key"
                v-for="(value, key, index) in pageDetails.allowedIssuers"
                :key="index"
              ></button-issuer>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import buttonIssuer from "@/components/form/button-issuer.vue";

import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "paymentMethodIdeal",
  data() {
    return {
      form: {
        issuer: "",
      },
    };
  },
  components: {
    buttonIssuer,
  },
  computed: {
    ...paymentNS.mapGetters(["pageDetails"]),
  },
  methods: {
    ...paymentNS.mapActions(["updateState"]),
  },
};
</script>
